import styled from '@emotion/styled';
import { Color, WarningIcon } from '@liveoptics/react-ui';
import React, { useCallback, useState } from 'react';
import { ProjectStatus, TheaterType, UserRole } from '../../../enums';
import { VerifyOwnerModal } from '../../modals';

export interface VerifyOwnerButtonProps {
  projectId: number;
  defaultTheater: TheaterType;
  userRole: UserRole | string;
  ownershipVerified: boolean;
  ownerId: number;
  projectStatus: ProjectStatus | string;
  onSuccess: () => void;
}

const Button = styled.button`
  color: ${Color.gold700};
  background-color: #fae3a6;
  font-size: 14px !important;
  line-height: 22px;
  letter-spacing: 0.14px;
  border: none;
  border-radius: 15px;
  padding: 5px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  svg {
    fill: ${Color.gold600};
    color: ${Color.gold600};
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
`;

export const VerifyOwnerButton = (props: VerifyOwnerButtonProps) => {
  const [showVerifyOwnerModal, setShowVerifyOwnerModal] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);

  const toggleModal = useCallback(
    (value: boolean) => () => {
      setShowVerifyOwnerModal(value);
      if (!value && success) props.onSuccess();
    },
    [props, success]
  );

  const handleSuccess = useCallback(() => setSuccess(true), []);

  const isValidProject =
    (props.userRole === UserRole.DellAdminUser || props.userRole === UserRole.DellUser) &&
    !props.ownershipVerified &&
    props.ownerId === 1 &&
    (props.projectStatus === ProjectStatus.Completed ||
      props.projectStatus === ProjectStatus.CompletedAndEmailSent);
  if (isValidProject)
    return (
      <>
        <Button onClick={toggleModal(true)}>
          <WarningIcon />
          Verify Owner
        </Button>
        {showVerifyOwnerModal ? (
          <VerifyOwnerModal
            projectId={props.projectId}
            defaultTheater={props.defaultTheater}
            onSuccess={handleSuccess}
            onClose={toggleModal(false)}
          />
        ) : (
          <></>
        )}
      </>
    );

  return <></>;
};
